import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../../styles/AccountConfirmed.css';

const AccountConfirmed = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading');
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const statusParam = searchParams.get('status');

    if (statusParam === 'success') {
      setStatus('success');

      // Countdown para redirecionamento
      const timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            navigate('/');
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    } else if (statusParam === 'error') {
      setStatus('error');
    } else {
      setStatus('invalid');
    }
  }, [searchParams, navigate]);

  return (
    <div className="account-confirmed-page">
      <div className="confirmation-card">
        {status === 'success' && (
          <>
            <div className="icon success-icon">✅</div>
            <h1>Conta Confirmada!</h1>
            <p>Sua conta foi ativada com sucesso!</p>
            <p className="redirect-text">
              Redirecionando em {countdown} segundo{countdown !== 1 ? 's' : ''}...
            </p>
            <button
              className="btn-primary"
              onClick={() => navigate('/')}
            >
              Ir para o Início Agora
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="icon error-icon">❌</div>
            <h1>Erro na Confirmação</h1>
            <p>Não foi possível confirmar sua conta.</p>
            <p className="error-text">O link pode ter expirado ou é inválido.</p>
            <button
              className="btn-secondary"
              onClick={() => navigate('/')}
            >
              Voltar ao Início
            </button>
          </>
        )}

        {status === 'loading' && (
          <>
            <div className="icon loading-icon">⏳</div>
            <h1>Verificando...</h1>
            <p>Aguarde enquanto confirmamos sua conta.</p>
          </>
        )}

        {status === 'invalid' && (
          <>
            <div className="icon error-icon">⚠️</div>
            <h1>Link Inválido</h1>
            <p>Este link de confirmação não é válido.</p>
            <button
              className="btn-secondary"
              onClick={() => navigate('/')}
            >
              Voltar ao Início
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default AccountConfirmed;